export default __webpack_public_path__ + "static/task-list-4a8dd071cdc1d8c4dc6a019d5101f414.mp4";